<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>

  </div>
</template>

<script>
export default {
  name:'app'
}
</script>



// WEBPACK FOOTER //
// App.vue?464530b4